import * as React from 'react';
import { TinyLink } from 'components/TinyLink/TinyLink';
import { Trans } from 'react-i18next';
import { RootStore, withInjectedRootStore } from 'providers';
import s from '../CheckoutPage.scss';
import { Text } from 'wix-style-react';
import { TermsOfUseLinksByBrand } from '../../../constants';

const TermOfUseComp: React.FC<{ rootStore: RootStore }> = ({ rootStore }) => {
  const {
    isEnterprise,
    appContext: { brand },
  } = rootStore.appStore;
  return (
    <span className={s.terms}>
      <Text weight='thin' size='tiny' dataHook='legal-disclaimer' secondary>
        <Trans
          i18nKey={
            isEnterprise
              ? 'checkout.disclaimer_enterprise_terms_of_service'
              : 'checkout.disclaimer_terms_of_service'
          }
        >
          By clicking Submit Purchase, you agree to our&nbsp;
          {isEnterprise ? (
            <TinyLink link={TermsOfUseLinksByBrand[brand].enterprise}>
              Enterprise Terms of Use
            </TinyLink>
          ) : (
            <TinyLink link={TermsOfUseLinksByBrand[brand].terms}>
              Terms of Use
            </TinyLink>
          )}
          &nbsp;and&nbsp;
          <TinyLink link={TermsOfUseLinksByBrand[brand].privacy}>
            Privacy Policy
          </TinyLink>
          .
        </Trans>
      </Text>
    </span>
  );
};

export const TermOfUse = withInjectedRootStore(TermOfUseComp);
